import styled, { css } from 'styled-components';
import { ModalBackdropStyled } from '@bechtel/gds';
import { Box } from '@bechtel/gds';
import { listWidth, smallScreenListWidth } from '../styled';

export const DrawerBackdropStyled = styled(ModalBackdropStyled)`
  position: absolute;
  left: ${listWidth};

  @media only screen and (max-width: ${({ theme }) => theme.breakpoints.widescreen}) {
    left: ${smallScreenListWidth};
  }
`;

export const DrawerOuterStyled = styled.div`
  background-color: ${({ theme }) => theme.colors.white};
  display: flex;
  flex-direction: column;
  height: 100%;
  left: 0;
  overflow: hidden;
  position: absolute;
  top: 0;
  width: ${listWidth};
`;

export const DrawerListSelectionStyled = styled.label`
  align-items: center;
  border-bottom: 1px solid ${({ theme }) => theme.colors.grey[300]};
  cursor: pointer;
  display: flex;
  flex-direction: row;
  padding: ${({ theme }) => theme.spacings[500]};

  flex-grow: 1;
  &:hover {
    background-color: ${({ theme }) => theme.colors.grey[100]};
  }
`;

export const ListSelectionHeadingStyled = styled(DrawerListSelectionStyled)`
  background-color: ${({ theme }) => theme.colors.grey[100]};
`;
